/**
 * @generated SignedSource<<6cce68b28bba9f8eef2c8d959a810abb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ClipModalQuery$variables = {
  id: string;
};
export type ClipModalQuery$data = {
  readonly node: {
    readonly __typename: string;
    readonly " $fragmentSpreads": FragmentRefs<"ClipModal_clip">;
  } | null;
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"TranscriptModal_viewer">;
  };
};
export type ClipModalQuery = {
  response: ClipModalQuery$data;
  variables: ClipModalQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerCanEdit",
  "storageKey": null
},
v6 = [
  (v3/*: any*/)
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "meetingCallEnd",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isGuest",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "image",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "timestamp",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isTopUser",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "user",
  "plural": false,
  "selections": (v6/*: any*/),
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "concreteType": "RecordingParticipant",
  "kind": "LinkedField",
  "name": "allRelevantParticipants",
  "plural": true,
  "selections": [
    (v8/*: any*/),
    (v9/*: any*/),
    (v11/*: any*/),
    (v13/*: any*/),
    (v14/*: any*/)
  ],
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "RecordingParticipant",
  "kind": "LinkedField",
  "name": "allRelevantParticipants",
  "plural": true,
  "selections": [
    (v9/*: any*/),
    (v8/*: any*/),
    (v11/*: any*/),
    (v13/*: any*/),
    (v14/*: any*/)
  ],
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isConnected",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ClipModalQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ClipModal_clip"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Literal",
                "name": "isPublic",
                "value": false
              }
            ],
            "kind": "FragmentSpread",
            "name": "TranscriptModal_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ClipModalQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "clipEnd",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "clipStart",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "summary",
                "storageKey": null
              },
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "transcript",
                "storageKey": null
              },
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "mediaType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Channel",
                "kind": "LinkedField",
                "name": "postedInChannels",
                "plural": true,
                "selections": (v6/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MeetingRecording",
                "kind": "LinkedField",
                "name": "baseRecording",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "meetingCallStart",
                    "storageKey": null
                  },
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "note",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "url",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "eventStart",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "eventEnd",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isLocked",
                            "storageKey": null
                          },
                          (v5/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "NoteUser",
                            "kind": "LinkedField",
                            "name": "noteuserSet",
                            "plural": true,
                            "selections": [
                              (v3/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "User",
                                "kind": "LinkedField",
                                "name": "user",
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/),
                                  (v8/*: any*/),
                                  (v9/*: any*/),
                                  (v10/*: any*/),
                                  (v11/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Event",
                            "kind": "LinkedField",
                            "name": "event",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "User",
                                "kind": "LinkedField",
                                "name": "organizer",
                                "plural": false,
                                "selections": (v6/*: any*/),
                                "storageKey": null
                              },
                              (v3/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "Note",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "ownerAccount",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "logo",
                    "storageKey": null
                  },
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isFavourite",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "meetingRecordedVideoUrl",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "transcriptTxtDownloadUrl",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "meetingRecordedVideoPosterUrl",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "viewCount",
                    "storageKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "userVideoProgress",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MeetingRecordingClip",
                        "kind": "LinkedField",
                        "name": "clips",
                        "plural": true,
                        "selections": (v6/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "didViewerAttend",
                        "storageKey": null
                      },
                      (v7/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "aiArtifactsTxtDownloadUrl",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MeetingRecordingSummary",
                        "kind": "LinkedField",
                        "name": "activeSummary",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TranscriptChapter",
                            "kind": "LinkedField",
                            "name": "chapters",
                            "plural": true,
                            "selections": [
                              (v12/*: any*/),
                              (v4/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TranscriptBulletPoint",
                                "kind": "LinkedField",
                                "name": "bulletPoints",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "text",
                                    "storageKey": null
                                  },
                                  (v12/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "textShort",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "context",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MeetingKeyEvent",
                        "kind": "LinkedField",
                        "name": "meetingKeyEvents",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "eventType",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "participantName",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "timeFromRecordingStart",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "endTimeFromRecordingStart",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "duration",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MeetingRecordingCommentsData",
                        "kind": "LinkedField",
                        "name": "comments",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "threadId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "startTimestamp",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "endTimestamp",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "count",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "users",
                            "plural": true,
                            "selections": [
                              (v3/*: any*/),
                              (v8/*: any*/),
                              (v9/*: any*/),
                              (v11/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isExternal",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "canRegenerateSummary",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "showLowLanguageConfidenceRegenerationBanner",
                        "storageKey": null
                      },
                      (v15/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "detectedLanguage",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "languageConfidenceScore",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "regenerationForLanguageIsInProgress",
                        "storageKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "MeetingRecording",
                                "kind": "LinkedField",
                                "name": "baseRecording",
                                "plural": false,
                                "selections": [
                                  (v16/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "MeetingRecordingClip",
                            "abstractKey": null
                          }
                        ],
                        "type": "MeetingRecordingInterface",
                        "abstractKey": "__isMeetingRecordingInterface"
                      }
                    ],
                    "type": "MeetingRecording",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MeetingRecording",
                        "kind": "LinkedField",
                        "name": "baseRecording",
                        "plural": false,
                        "selections": [
                          (v15/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "MeetingRecording",
                                    "kind": "LinkedField",
                                    "name": "baseRecording",
                                    "plural": false,
                                    "selections": [
                                      (v16/*: any*/),
                                      (v3/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "MeetingRecordingClip",
                                "abstractKey": null
                              }
                            ],
                            "type": "MeetingRecordingInterface",
                            "abstractKey": "__isMeetingRecordingInterface"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "MeetingRecordingClip",
                    "abstractKey": null
                  }
                ],
                "type": "MeetingRecordingInterface",
                "abstractKey": "__isMeetingRecordingInterface"
              }
            ],
            "type": "MeetingRecordingClip",
            "abstractKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserVideoPlaybackSettings",
            "kind": "LinkedField",
            "name": "videoPlaybackSettings",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "playbackRate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "subtitlesEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "volume",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "muted",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Account",
            "kind": "LinkedField",
            "name": "account",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "allowRecapDownload",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "allowRecapEngagementStats",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "allowAiFeatures",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "BillingAccount",
                "kind": "LinkedField",
                "name": "billingAccount",
                "plural": false,
                "selections": [
                  {
                    "alias": "hasAccessToRecapTemplates",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "feature",
                        "value": "recap_templates"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "hasAccessToFeature",
                    "storageKey": "hasAccessToFeature(feature:\"recap_templates\")"
                  },
                  (v3/*: any*/),
                  {
                    "alias": "hasAccessToDuedates",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "feature",
                        "value": "duedates"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "hasAccessToFeature",
                    "storageKey": "hasAccessToFeature(feature:\"duedates\")"
                  },
                  {
                    "alias": "hasAccessToVersioning",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "feature",
                        "value": "versioning"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "hasAccessToFeature",
                    "storageKey": "hasAccessToFeature(feature:\"versioning\")"
                  },
                  {
                    "alias": "hasAccessToSharing",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "feature",
                        "value": "sharing"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "hasAccessToFeature",
                    "storageKey": "hasAccessToFeature(feature:\"sharing\")"
                  },
                  {
                    "alias": "hasAccessToJiraIntegration",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "feature",
                        "value": "jira_integration"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "hasAccessToFeature",
                    "storageKey": "hasAccessToFeature(feature:\"jira_integration\")"
                  },
                  {
                    "alias": "hasAccessToComments",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "feature",
                        "value": "comments"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "hasAccessToFeature",
                    "storageKey": "hasAccessToFeature(feature:\"comments\")"
                  },
                  {
                    "alias": "hasAccessToMeetingFeedback",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "feature",
                        "value": "meeting_feedback"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "hasAccessToFeature",
                    "storageKey": "hasAccessToFeature(feature:\"meeting_feedback\")"
                  },
                  {
                    "alias": "hasAccessToNoteLocking",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "feature",
                        "value": "note_locking"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "hasAccessToFeature",
                    "storageKey": "hasAccessToFeature(feature:\"note_locking\")"
                  },
                  {
                    "alias": "hasAccessToZapierIntegration",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "feature",
                        "value": "zapier_integration"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "hasAccessToFeature",
                    "storageKey": "hasAccessToFeature(feature:\"zapier_integration\")"
                  },
                  {
                    "alias": "hasAccessToEmbeds",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "feature",
                        "value": "embeds"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "hasAccessToFeature",
                    "storageKey": "hasAccessToFeature(feature:\"embeds\")"
                  },
                  {
                    "alias": "hasAccessToSalesforce",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "feature",
                        "value": "salesforce_integration"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "hasAccessToFeature",
                    "storageKey": "hasAccessToFeature(feature:\"salesforce_integration\")"
                  },
                  {
                    "alias": "hasAccessToHubspot",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "feature",
                        "value": "hubspot_integration"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "hasAccessToFeature",
                    "storageKey": "hasAccessToFeature(feature:\"hubspot_integration\")"
                  },
                  {
                    "alias": "hasAccessToAsana",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "feature",
                        "value": "asana_integration"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "hasAccessToFeature",
                    "storageKey": "hasAccessToFeature(feature:\"asana_integration\")"
                  },
                  {
                    "alias": "hasAccessToObjectives",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "feature",
                        "value": "objectives"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "hasAccessToFeature",
                    "storageKey": "hasAccessToFeature(feature:\"objectives\")"
                  },
                  {
                    "alias": "hasAccessToPromptHeadings",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "feature",
                        "value": "prompt_headings"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "hasAccessToFeature",
                    "storageKey": "hasAccessToFeature(feature:\"prompt_headings\")"
                  },
                  {
                    "alias": "hasAccessToNotesIntegrationExport",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "feature",
                        "value": "notes_integration_export"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "hasAccessToFeature",
                    "storageKey": "hasAccessToFeature(feature:\"notes_integration_export\")"
                  },
                  {
                    "alias": "hasAccessToMultipleAssignees",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "feature",
                        "value": "multiple_assignees"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "hasAccessToFeature",
                    "storageKey": "hasAccessToFeature(feature:\"multiple_assignees\")"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "featureAccess",
                    "storageKey": null
                  },
                  {
                    "alias": "hasCopilotAddon",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "feature",
                        "value": "meeting_recorder"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "hasAccessToFeature",
                    "storageKey": "hasAccessToFeature(feature:\"meeting_recorder\")"
                  },
                  {
                    "alias": "hasAccessToRedaction",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "feature",
                        "value": "redaction"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "hasAccessToFeature",
                    "storageKey": "hasAccessToFeature(feature:\"redaction\")"
                  },
                  {
                    "alias": "hasAccessToRecapComments",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "feature",
                        "value": "recap_comments"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "hasAccessToFeature",
                    "storageKey": "hasAccessToFeature(feature:\"recap_comments\")"
                  },
                  {
                    "alias": "hasAccessToPrivateRecapComments",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "feature",
                        "value": "recap_private_comments"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "hasAccessToFeature",
                    "storageKey": "hasAccessToFeature(feature:\"recap_private_comments\")"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "loomEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Tag",
                "kind": "LinkedField",
                "name": "tags",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "label",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "color",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountIntegrations",
                "kind": "LinkedField",
                "name": "integrations",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "JiraAccountNode",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "clientKey",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "baseUrl",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "allowMeetingRecording",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "allowMeetingRecordingRedaction",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v10/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "firstName",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "uxSimplificationEnabled",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "connectedActionItemIntegrations",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserIntegrations",
            "kind": "LinkedField",
            "name": "integrations",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AsanaUserNode",
                "kind": "LinkedField",
                "name": "asana",
                "plural": false,
                "selections": [
                  (v17/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ZoomUserNode",
                "kind": "LinkedField",
                "name": "zoom",
                "plural": false,
                "selections": [
                  (v17/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasLocalRecordingTokenScope",
                    "storageKey": null
                  },
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasAccessToCopilot",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserMeetingRecapAutoShareSettings",
            "kind": "LinkedField",
            "name": "meetingRecapAutoShareSettings",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sendTo",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastUsedBrowserExtension",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canCreateWorkspaceTemplate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "remainingMeetingRecordingCredits",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasAccessToScheduledMeetingRecordings",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasAdminAccess",
            "storageKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f673faa16cd6996839359b8d998c384f",
    "id": null,
    "metadata": {},
    "name": "ClipModalQuery",
    "operationKind": "query",
    "text": "query ClipModalQuery(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...ClipModal_clip\n    id\n  }\n  viewer {\n    ...TranscriptModal_viewer_3PTmlf\n    id\n  }\n}\n\nfragment ClipModal_clip on MeetingRecordingClip {\n  id\n  clipEnd\n  clipStart\n  summary\n  title\n  transcript\n  viewerCanEdit\n  mediaType\n  postedInChannels {\n    id\n  }\n  baseRecording {\n    id\n    title\n    meetingCallStart\n    meetingCallEnd\n    note {\n      __typename\n      id\n      ... on Note {\n        url\n        eventStart\n        eventEnd\n      }\n      ...TranscriptPanel_note\n    }\n  }\n  ownerAccount {\n    __typename\n    name\n    logo\n    id\n  }\n  ...TranscriptVideo_meetingRecording_1DbIRQ\n  ...TranscriptPanel_Transcript_meetingRecording_1DbIRQ\n  ...utils_useGetURL_recording\n  ...ClipsPanel_RenameClipModal_clip\n}\n\nfragment ClipsPanel_RenameClipModal_clip on MeetingRecordingClip {\n  id\n  title\n}\n\nfragment DeleteMeeting_viewer on Viewer {\n  user {\n    isGuest\n    id\n  }\n}\n\nfragment HighlightsPanel_viewer on Viewer {\n  account {\n    __typename\n    allowAiFeatures\n    billingAccount {\n      hasAccessToRecapTemplates: hasAccessToFeature(feature: recap_templates)\n      id\n    }\n    id\n  }\n}\n\nfragment JoinConferenceButton_viewer on Viewer {\n  uxSimplificationEnabled\n  lastUsedBrowserExtension\n  integrations {\n    zoom {\n      isConnected\n      hasLocalRecordingTokenScope\n      id\n    }\n  }\n}\n\nfragment LockNote_viewer on Viewer {\n  account {\n    billingAccount {\n      hasAccessToNoteLocking: hasAccessToFeature(feature: note_locking)\n      id\n    }\n    id\n  }\n}\n\nfragment MeetingContainerModalNote_viewer on Viewer {\n  uxSimplificationEnabled\n  user {\n    id\n    isGuest\n    firstName\n  }\n  account {\n    loomEnabled\n    tags {\n      __typename\n      id\n      label\n      color\n    }\n    billingAccount {\n      hasAccessToDuedates: hasAccessToFeature(feature: duedates)\n      hasAccessToVersioning: hasAccessToFeature(feature: versioning)\n      hasAccessToSharing: hasAccessToFeature(feature: sharing)\n      hasAccessToJiraIntegration: hasAccessToFeature(feature: jira_integration)\n      hasAccessToComments: hasAccessToFeature(feature: comments)\n      hasAccessToMeetingFeedback: hasAccessToFeature(feature: meeting_feedback)\n      hasAccessToNoteLocking: hasAccessToFeature(feature: note_locking)\n      hasAccessToZapierIntegration: hasAccessToFeature(feature: zapier_integration)\n      hasAccessToEmbeds: hasAccessToFeature(feature: embeds)\n      hasAccessToSalesforce: hasAccessToFeature(feature: salesforce_integration)\n      hasAccessToHubspot: hasAccessToFeature(feature: hubspot_integration)\n      hasAccessToAsana: hasAccessToFeature(feature: asana_integration)\n      hasAccessToObjectives: hasAccessToFeature(feature: objectives)\n      hasAccessToPromptHeadings: hasAccessToFeature(feature: prompt_headings)\n      hasAccessToNotesIntegrationExport: hasAccessToFeature(feature: notes_integration_export)\n      hasAccessToMultipleAssignees: hasAccessToFeature(feature: multiple_assignees)\n      featureAccess\n      id\n    }\n    integrations {\n      jira {\n        id\n        clientKey\n        baseUrl\n      }\n    }\n    id\n  }\n  connectedActionItemIntegrations\n  integrations {\n    asana {\n      isConnected\n      id\n    }\n  }\n}\n\nfragment MeetingPhaseContext_viewer on Viewer {\n  ...featureFlag_useCopilotPaywallsOn_viewer\n  remainingMeetingRecordingCredits\n  hasAccessToCopilot\n  hasAccessToScheduledMeetingRecordings\n  hasAdminAccess\n  account {\n    allowMeetingRecording\n    id\n  }\n  user {\n    id\n  }\n  meetingRecapAutoShareSettings {\n    id\n    sendTo\n  }\n}\n\nfragment MoreActionsMenuNote_viewer on Viewer {\n  user {\n    id\n    isGuest\n  }\n  account {\n    allowAiFeatures\n    id\n  }\n  ...SaveAsTemplate_viewer\n  ...VersionHistory_viewer\n  ...LockNote_viewer\n  ...DeleteMeeting_viewer\n}\n\nfragment NoteHeader_viewer on Viewer {\n  user {\n    isGuest\n    id\n  }\n  ...RecordingControls_viewer\n  ...JoinConferenceButton_viewer\n  ...MoreActionsMenuNote_viewer\n}\n\nfragment RecordingControls_viewer on Viewer {\n  hasAccessToCopilot\n  ...StartAndAutoRecordingControls_viewer\n}\n\nfragment RegenerateForLanguageModalFragment_meetingRecording on MeetingRecording {\n  id\n  detectedLanguage\n  languageConfidenceScore\n  canRegenerateSummary\n  regenerationForLanguageIsInProgress\n}\n\nfragment SaveAsTemplate_viewer on Viewer {\n  canCreateWorkspaceTemplate\n  account {\n    billingAccount {\n      hasAccessToPromptHeadings: hasAccessToFeature(feature: prompt_headings)\n      id\n    }\n    id\n  }\n}\n\nfragment StartAndAutoRecordingControls_viewer on Viewer {\n  hasAccessToCopilot\n  meetingRecapAutoShareSettings {\n    id\n    sendTo\n  }\n  account {\n    billingAccount {\n      hasCopilotAddon: hasAccessToFeature(feature: meeting_recorder)\n      id\n    }\n    id\n  }\n  ...StreamAutoRecordAutomationConfig_useAutoRecordReason_viewer\n}\n\nfragment StatsPanel_viewer on Viewer {\n  user {\n    isGuest\n    id\n  }\n}\n\nfragment StreamAutoRecordAutomationConfig_useAutoRecordReason_viewer on Viewer {\n  hasAccessToCopilot\n}\n\nfragment Timeline_meetingKeyEvents on MeetingRecording {\n  meetingKeyEvents {\n    eventType\n    participantName\n    timeFromRecordingStart\n    endTimeFromRecordingStart\n    duration\n  }\n  comments {\n    threadId\n    startTimestamp\n  }\n}\n\nfragment TranscriptModal_viewer_3PTmlf on Viewer {\n  videoPlaybackSettings {\n    ...TranscriptVideo_videoPlaybackSettings\n    id\n  }\n  account {\n    __typename\n    id\n    allowRecapDownload\n    allowRecapEngagementStats\n  }\n  user {\n    isGuest\n    id\n  }\n  ...HighlightsPanel_viewer\n  ...MeetingContainerModalNote_viewer\n  ...NoteHeader_viewer\n  ...MeetingPhaseContext_viewer\n  ...TranscriptPanel_Transcript_viewer\n  ...StatsPanel_viewer\n}\n\nfragment TranscriptPanel_LowLanguageConfidenceRegenerationBanner_meetingRecording_1DbIRQ on MeetingRecordingInterface {\n  __isMeetingRecordingInterface: __typename\n  ... on MeetingRecording {\n    id\n    detectedLanguage\n    languageConfidenceScore\n    ...RegenerateForLanguageModalFragment_meetingRecording\n  }\n}\n\nfragment TranscriptPanel_RelabelMultipleSpeakersModal_meetingRecording_1DbIRQ on MeetingRecordingInterface {\n  __isMeetingRecordingInterface: __typename\n  __typename\n  id\n  transcript\n  meetingRecordedVideoUrl\n  ... on MeetingRecording {\n    allRelevantParticipants {\n      ...TranscriptPanel_SpeakerRelabelForm_attendees\n    }\n  }\n  ... on MeetingRecordingClip {\n    baseRecording {\n      allRelevantParticipants {\n        ...TranscriptPanel_SpeakerRelabelForm_attendees\n      }\n      id\n    }\n  }\n}\n\nfragment TranscriptPanel_SpeakerRelabelForm_attendees on RecordingParticipant {\n  email\n  fullName\n  image\n  isTopUser\n  user {\n    id\n  }\n}\n\nfragment TranscriptPanel_TranscriptSegment_meetingRecording on MeetingRecordingInterface {\n  __isMeetingRecordingInterface: __typename\n  id\n  ownerAccount {\n    __typename\n    id\n  }\n  ...utils_useGetURL_recording\n}\n\nfragment TranscriptPanel_TranscriptSegment_note on Note {\n  id\n}\n\nfragment TranscriptPanel_Transcript_meetingRecording_1DbIRQ on MeetingRecordingInterface {\n  __isMeetingRecordingInterface: __typename\n  __typename\n  id\n  meetingRecordedVideoUrl\n  ... on MeetingRecording {\n    activeSummary {\n      id\n    }\n    canRegenerateSummary\n    comments {\n      threadId\n      startTimestamp\n      endTimestamp\n      count\n      users {\n        id\n        email\n        fullName\n        image\n        isExternal\n      }\n    }\n    showLowLanguageConfidenceRegenerationBanner\n  }\n  ownerAccount {\n    __typename\n    id\n  }\n  ...TranscriptPanel_TranscriptSegment_meetingRecording\n  ...Timeline_meetingKeyEvents\n  ...TranscriptPanel_makeSpeakerNameToUserMapping_meetingRecording_1DbIRQ\n  ...TranscriptPanel_RelabelMultipleSpeakersModal_meetingRecording_1DbIRQ\n  ...TranscriptPanel_UnlabeledSpeakersWarning_meetingRecording\n  ...TranscriptPanel_LowLanguageConfidenceRegenerationBanner_meetingRecording_1DbIRQ\n}\n\nfragment TranscriptPanel_Transcript_viewer on Viewer {\n  account {\n    allowAiFeatures\n    allowMeetingRecordingRedaction\n    billingAccount {\n      hasAccessToRedaction: hasAccessToFeature(feature: redaction)\n      hasAccessToRecapComments: hasAccessToFeature(feature: recap_comments)\n      hasAccessToPrivateRecapComments: hasAccessToFeature(feature: recap_private_comments)\n      id\n    }\n    id\n  }\n}\n\nfragment TranscriptPanel_UnlabeledSpeakersWarning_meetingRecording on MeetingRecordingInterface {\n  __isMeetingRecordingInterface: __typename\n  transcript\n  ownerAccount {\n    __typename\n    id\n  }\n}\n\nfragment TranscriptPanel_makeSpeakerNameToUserMapping_meetingRecording_1DbIRQ on MeetingRecordingInterface {\n  __isMeetingRecordingInterface: __typename\n  ... on MeetingRecording {\n    ... on MeetingRecordingInterface {\n      __isMeetingRecordingInterface: __typename\n      ... on MeetingRecording {\n        allRelevantParticipants {\n          fullName\n          email\n          image\n          isTopUser\n          user {\n            id\n          }\n        }\n      }\n      ... on MeetingRecordingClip {\n        baseRecording {\n          allRelevantParticipants {\n            fullName\n            email\n            image\n            isTopUser\n            user {\n              id\n            }\n          }\n          id\n        }\n      }\n    }\n  }\n  ... on MeetingRecordingClip {\n    baseRecording {\n      ... on MeetingRecordingInterface {\n        __isMeetingRecordingInterface: __typename\n        ... on MeetingRecording {\n          allRelevantParticipants {\n            fullName\n            email\n            image\n            isTopUser\n            user {\n              id\n            }\n          }\n        }\n        ... on MeetingRecordingClip {\n          baseRecording {\n            allRelevantParticipants {\n              fullName\n              email\n              image\n              isTopUser\n              user {\n                id\n              }\n            }\n            id\n          }\n        }\n      }\n      id\n    }\n  }\n}\n\nfragment TranscriptPanel_note on Note {\n  id\n  isLocked\n  viewerCanEdit\n  noteuserSet {\n    id\n    user {\n      id\n      email\n      fullName\n      isGuest\n      image\n    }\n  }\n  event {\n    organizer {\n      id\n    }\n    id\n  }\n  ...TranscriptPanel_TranscriptSegment_note\n}\n\nfragment TranscriptVideo_meetingRecording_1DbIRQ on MeetingRecordingInterface {\n  __isMeetingRecordingInterface: __typename\n  __typename\n  id\n  ... on MeetingRecording {\n    userVideoProgress\n    clips {\n      id\n    }\n    didViewerAttend\n  }\n  ...Video_meetingRecording\n}\n\nfragment TranscriptVideo_videoPlaybackSettings on UserVideoPlaybackSettings {\n  id\n  playbackRate\n  subtitlesEnabled\n  volume\n  muted\n}\n\nfragment VersionHistory_viewer on Viewer {\n  account {\n    billingAccount {\n      hasAccessToVersioning: hasAccessToFeature(feature: versioning)\n      id\n    }\n    id\n  }\n}\n\nfragment Video_meetingRecording on MeetingRecordingInterface {\n  __isMeetingRecordingInterface: __typename\n  __typename\n  id\n  createdAt\n  isFavourite\n  meetingRecordedVideoUrl\n  transcriptTxtDownloadUrl\n  meetingRecordedVideoPosterUrl\n  viewCount\n  mediaType\n  ... on MeetingRecording {\n    meetingCallEnd\n    aiArtifactsTxtDownloadUrl\n    activeSummary {\n      chapters {\n        timestamp\n        title\n        bulletPoints {\n          text\n          timestamp\n          textShort\n          context\n        }\n      }\n      id\n    }\n    ...Timeline_meetingKeyEvents\n  }\n}\n\nfragment featureFlag_useCopilotPaywallsOn_viewer on Viewer {\n  account {\n    billingAccount {\n      hasCopilotAddon: hasAccessToFeature(feature: meeting_recorder)\n      id\n    }\n    id\n  }\n}\n\nfragment utils_useGetURL_recording on MeetingRecordingInterface {\n  __isMeetingRecordingInterface: __typename\n  __typename\n  ... on MeetingRecording {\n    id\n  }\n  ... on MeetingRecordingClip {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "131835f963dd9036051af55b84079b93";

export default node;
